<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OoSBMt/tc-custom/9781440523816.jpg?1730548085207" alt="This image is the cover for the book Everything Tex-Mex Cookbook, The Everything Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everything Tex-Mex Cookbook, The Everything Books
      </h1>
      <p class="bookDescription body article font2">
        <b>An American tradition since the 1800s, Tex-Mex food combines the flavors of a wide variety of ingredients with the influence of different cultures to create unique dishes that are crafted to perfection.</b><br/><br/>Tomatoes, beef, beans, chiles, and corn are the staples of Tex-Mex cooking, while flavor, texture, and personality are added with specialties such as hot sauce, chorizo, and spices such as chili pepper and cayenne pepper. Packed with 300 not-quite-south-of-the-border recipes, <i>The Everything Tex-Mex Cookbook</i> brings these authentic flavors to your very own kitchen.<br/><br/>Features recipes for:<br/> -Chilled Avocado Soup<br/> -Red Snapper Flautas<br/> -Oven Barbecued Beef Brisket<br/> -Chicken Chimichangas<br/> -Mixed Bean Lasagna<br/> -Red Sangria<br/> -Peach Daiquiri Pie<br/><br/>Whether you’re looking for a quick party appetizer, dinner for your family, or drinks and dessert, <i>The Everything Tex-Mex Cookbook</i> has everything you need to add some color and spice to your daily menus!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Larsen
      </h2>
      
      <p class="authorDescription body article">An Adams Media author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b2ffd8fa